import React from 'react'
import './Suggested.css'
import { useTransition } from 'react';
import { useTranslation } from 'react-i18next';

interface Champion {
    id: number;
    name: string;
    positions: string[];
    faction: string[];
    releaseYear: string[];
    src: string;
}

export const Suggested = (props: any) => {
  const {champsSuggested, squareSelected, inputValue, squareId, isChampionValid, uploadBoard, setChampsSuggested, setInputValue} = props;
  const {i18n, t} = useTranslation();

  const handleChampionSubmission = (champ: Champion) => {
    const row: string = "square"+squareId.charAt(6)+"0";
    const column: string = "square0"+squareId.charAt(7);
    const lastColumn: string = "square"+squareId.charAt(6)+"4";

    const rowElement = document.getElementById(row);
    const rowTrack = rowElement ? rowElement.getAttribute("data-value") : "";

    const columnElement = document.getElementById(column);
    const columnTrack = columnElement ? columnElement.getAttribute("data-value") : "";

    const lastColumnElement = document.getElementById(lastColumn);
    const lastColumnTrack = lastColumnElement ? lastColumnElement.getAttribute("data-value") : "";

    const tracks: Array<string> = [rowTrack, columnTrack,lastColumnTrack].filter(track => track !== null) as string[];
 
    if (isChampionValid(champ, tracks)) {
      uploadBoard(champ)
    } else {
      const inputElement = document.getElementById("inputSuggestions") as HTMLInputElement;
      if (inputElement) {
        inputElement.focus();
      }
    }
    setInputValue("")
    setChampsSuggested([])
  }

  return (
    <div className="containerSpans">
      {champsSuggested && champsSuggested.length > 0 ? (
        champsSuggested.map((champ: Champion) => (
          <span key={"key" + champ.id} onClick={() => handleChampionSubmission(champ)} className="spanSugg">
            <img className="miniImage" src={champ.src} alt="Image suggested champion" />
            {champ.name.charAt(0).toUpperCase() + champ.name.slice(1)}
          </span>
        ))
      ) : squareSelected && inputValue !== "" ? (
        <span className="spanNothing">{t('suggested.spanNothing')}</span>
      ) : null}
    </div>
  );
};
